import React from 'react'
import { Modal, Input } from 'antd'
import { toast } from 'react-toastify'
import { focusInputId } from '../focus-input'

/**
 * Muestra un modal para enviar un correo electrónico
 * @param {function} sendEmail
 * @param {object} emailData
 */
export const popoverEmail = (sendEmail, emailData) => {
  Modal.info({
    centered: true,
    maskClosable: true,
    title: 'Enviar comprobante por correo',
    okText: 'Enviar',
    okButtonProps: {
      className: 'bg-purple border-0'
    },
    onOk() {
      const email = document.getElementById('popover-email-input')?.value ?? null
      if (!email) {
        toast.error('Ingrese un correo electrónico válido')
        return Promise.reject('Correo electrónico no válido')
      }
      sendEmail({ ...emailData, to: email })
    },
    content: (
      <Input
        required
        id="popover-email-input"
        type="email"
        placeholder="Correo electrónico"
        defaultValue={emailData?.to}
        onPressEnter={() => {
          const email = document.getElementById('popover-email-input')?.value ?? null
          if (!email) {
            toast.error('Ingrese un correo electrónico válido')
            return
          }
          sendEmail({ ...emailData, to: email })
          Modal.destroyAll()
        }}
      />
    )
  })
  setTimeout(() => focusInputId('popover-email-input', true), 100)
}
